import { mutator } from 'satcheljs';
import updateCalendarProcessingOptions from '../../actions/updateCalendarProcessingOptions';
import CalendarProcessingOptions from 'owa-service/lib/contract/CalendarProcessingOptions';
import getCalendarOptions from '../../utils/getCalendarOptions';
const assign = require('object-assign');

/**
 * Update calendar processing options in store
 */

export default mutator(updateCalendarProcessingOptions, actionMessage => {
    assign(getCalendarOptions(), actionMessage.calendarProcessingOptions);
});

export { CalendarProcessingOptions };
